import React, { FC, useEffect } from 'react'

import { useParams } from 'react-router-dom'
import styled from 'styled-components'

import { SchedulePaymentMethod } from 'src/Components/SchedulePaymentMethod'
import { ScheduleSummary } from 'src/Components/ScheduleSummary'
import { ScheduleCheckoutErrors } from 'src/Components/ScheduleCheckoutErrors'
import { useAppDispatch, useAppSelector } from 'src/Hooks/redux'
import {
  getPaymentAlertError,
  getPaymentMethod,
} from 'src/Redux/payment-process/selectors'
import { setPaymentMethod } from 'src/Redux/payment-process'
import { MAX_MOBILE_WIDTH } from 'src/Styled/variables'
import { useGetMetaAdsCampaignByIdQuery } from 'src/Redux/adsCampaignApi'

import { useAdsSchedulePaymentMethod } from './useAdsSchedulePaymentMethod'
import { useAdsScheduleOrderSummary } from './useAdsScheduleOrderSummary'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  @media screen and (min-width: ${MAX_MOBILE_WIDTH}) {
    align-items: flex-start;
    flex-direction: row;
    align-self: stretch;
  }
`

export const AdsScheduleOrderCheckoutPage: FC = () => {
  const { number } = useParams()
  const dispatch = useAppDispatch()
  const adsSchedulePaymentMethodProps = useAdsSchedulePaymentMethod({
    isOrderBased: true,
  })
  const {
    availablePaymentMethods,
    isOrderFullyCovered,
    ...adsScheduleSummaryProps
  } = useAdsScheduleOrderSummary()
  const { data: metaAdsCampaign } = useGetMetaAdsCampaignByIdQuery(
    Number(number),
  )

  const paymentError = useAppSelector(getPaymentAlertError)
  const paymentMethod = useAppSelector(getPaymentMethod)

  useEffect(() => {
    if (
      availablePaymentMethods?.length &&
      !availablePaymentMethods.includes(paymentMethod)
    ) {
      dispatch(setPaymentMethod(availablePaymentMethods[0]))
    }
  }, [availablePaymentMethods, paymentMethod, dispatch])

  const isConfirmDisabled = Boolean(
    availablePaymentMethods && !availablePaymentMethods.length,
  )

  const paymentMethodBlock = (
    <SchedulePaymentMethod
      {...adsSchedulePaymentMethodProps}
      isEnoughBalance={isOrderFullyCovered}
      allowedPaymentMethods={availablePaymentMethods}
    />
  )

  return (
    <>
      {paymentError && <ScheduleCheckoutErrors name={paymentError} />}
      <Wrapper>
        {paymentMethodBlock}
        <ScheduleSummary
          {...adsScheduleSummaryProps}
          confirmDisabled={isConfirmDisabled}
          isAutoRenewalInfoTextVisible={true}
          paymentMethod={paymentMethod}
          trackCover={metaAdsCampaign?.coverUrl}
        />
      </Wrapper>
    </>
  )
}
